import React from "react";
import styled from "styled-components";
import NextImage from "next/legacy/image";
import { P1 } from "../../atoms/Paragraph";
import { color } from "@styles";
import Santander from "../../../public/static/companies/companies-bar-colour/santander.svg";
import Paramount from "../../../public/static/companies/companies-bar-colour/paramount.svg";
import Tesco from "../../../public/static/companies/companies-bar-colour/tesco.svg";
import RightMove from "../../../public/static/companies/companies-bar-colour/rightmove.svg";
import Sodexo from "../../../public/static/companies/companies-bar-colour/sodexo.svg";
import CapitalOne from "../../../public/static/companies/companies-bar-colour/capitalone.svg";
import DelMonte from "../../../public/static/companies/companies-bar-colour/delmonte.svg";
import Curve from "../../../public/static/companies/companies-bar-colour/curve.svg";
import FinancialTimes from "../../../public/static/companies/companies-bar-colour/financialtimes.svg";
import Havas from "../../../public/static/companies/companies-bar-colour/havas.svg";
import What3Words from "../../../public/static/companies/companies-bar-colour/what3words.svg";
import Fujitsu from "../../../public/static/img/get-a-quote/logos/Fujitsu.svg";
import { useTranslations } from "next-intl";
import { useLocale } from "@hooks";

interface Props {
  title?: string;
}

export const CompaniesBar = ({ title }: Props) => {
  const t = useTranslations("home");
  const { locale } = useLocale();

  return (
    <>
      <CompaniesBarText align="center">{title || t<string>("customer-logos")}</CompaniesBarText>
      <CompaniesLogos>
        {locale !== "us" ? (
          <>
            <NextImage src={Tesco} alt="Tesco" />
            <NextImage src={What3Words} alt="What 3 Words" />
            <NextImage src={Paramount} alt="Paramount" />
            <NextImage src={Fujitsu} alt="Fujitsu" />
            <NextImage src={RightMove} alt="Right Move" />
            <NextImage src={Santander} alt="Santander" />
            <NextImage src={Sodexo} alt="Sodexo" />
          </>
        ) : (
          <>
            <NextImage src={Fujitsu} alt="Fujitsu" />
            <NextImage src={Paramount} alt="Paramount" />
            <NextImage src={DelMonte} alt="Del Monte" />
            <NextImage src={Curve} alt="Curve" />
            <NextImage src={FinancialTimes} alt="Financial Times" />
            <NextImage src={Havas} alt="Havas" />
            <NextImage src={What3Words} alt="What 3 Words" />
          </>
        )}
      </CompaniesLogos>
    </>
  );
};

const CompaniesLogos = styled.div<{ heroVariant?: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(p) => (p.heroVariant ? "flex-start" : "center")};
  margin: 1.5rem auto 1rem;
  column-gap: 4rem;
  row-gap: 2.5rem;

  svg {
    margin: 1.5rem 2.5rem;
    height: 2rem;
  }

  @media only screen and (max-width: 25rem) {
    svg {
      margin: 6vw 10vw;
      height: 8vw;
    }
  }
`;

const CompaniesBarText = styled(P1)`
  color: ${color.B1100};
  padding: 0 1rem;
`;
